/* hp-centered-mobile-shelves.js */
(() => {
  const centerShelf = (container, cardSelector) => {
    if (!container || container.dataset.hpCentered === 'true') return;
    const cards = Array.from(container.querySelectorAll(cardSelector)).filter((card) => card.offsetWidth > 0);
    if (cards.length < 2) return;
    const card = cards[Math.floor(cards.length / 2)];
    const left = card.offsetLeft - (container.clientWidth - card.offsetWidth) / 2;
    container.scrollLeft = Math.max(0, left);
    container.dataset.hpCentered = 'true';
  };

  const initialize = (root = document) => {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    requestAnimationFrame(() => {
      root.querySelectorAll('.hp-bestseller-scroll__rail').forEach((rail) => centerShelf(rail, '.hp-bestseller-card'));
      root.querySelectorAll('.hp-fresh-drop__viewport').forEach((viewport) => centerShelf(viewport, '.hp-fresh-drop__card'));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

;
/* hp-product-search-polish.js */
(() => {
  const corrections = new Map([
    ['coler', 'collar'], ['coller', 'collar'], ['colar', 'collar'],
    ['leesh', 'leash'], ['lesh', 'leash'], ['harnes', 'harness'],
    ['shampu', 'shampoo'], ['shampo', 'shampoo'], ['toye', 'toy'],
    ['dogg', 'dog'], ['dgo', 'dog'], ['catt', 'cat'], ['cta', 'cat'],
    ['groomng', 'grooming'], ['brushh', 'brush'], ['bowlle', 'bowl']
  ]);

  const correctedQuery = (value) => value.trim().split(/\s+/).map((word) => {
    const replacement = corrections.get(word.toLowerCase());
    if (!replacement) return word;
    return /^[A-Z]/.test(word) ? replacement.charAt(0).toUpperCase() + replacement.slice(1) : replacement;
  }).join(' ');

  const enhanceSearch = (form) => {
    const input = form.querySelector('input[type="search"]');
    if (!input || form.dataset.hpSearchEnhanced) return;
    form.dataset.hpSearchEnhanced = 'true';
    input.spellcheck = true;
    input.autocorrect = 'on';
    let hint;

    const clearHint = () => { hint?.remove(); hint = undefined; };
    const showHint = (query) => {
      clearHint();
      if (!query || query === input.value.trim()) return;
      hint = document.createElement('div');
      hint.className = 'hp-search-correction';
      hint.innerHTML = 'Did you mean <button type="button"></button>?';
      const button = hint.querySelector('button');
      button.textContent = query;
      button.addEventListener('click', () => {
        input.value = query;
        clearHint();
        input.dispatchEvent(new Event('input', { bubbles: true }));
        if (window.matchMedia('(max-width: 749px)').matches) form.submit();
      });
      form.append(hint);
    };

    input.addEventListener('input', () => showHint(correctedQuery(input.value)));
    form.addEventListener('submit', (event) => {
      const corrected = correctedQuery(input.value);
      if (corrected !== input.value.trim()) input.value = corrected;
    });
    document.addEventListener('click', (event) => { if (!form.contains(event.target)) clearHint(); });
  };

  const initialize = (root = document) => root.querySelectorAll('form[role="search"]').forEach(enhanceSearch);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
